import { Type } from "@sinclair/typebox";
import { ChatIdentifierSchema, VideoCallTypeSchema } from "../chat/chat";
export const WebRtcMessageCommonSchema = Type.Object({
    id: ChatIdentifierSchema,
    userId: Type.String(),
    threadRootMessageIndex: Type.Optional(Type.Number()),
});
const RemoteVideoCallStartedSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_video_call_started"),
        messageId: Type.BigInt(),
        callType: VideoCallTypeSchema,
    })]);
const RemoteVideoCallEndedSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_video_call_ended"),
        messageId: Type.BigInt(),
    })]);
const CurrentUserTypingSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("current_user_typing"),
    })]);
const CurrentUserStoppedTypingSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("current_user_stopped_typing"),
    })]);
const RemoteUserTypingSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_user_typing"),
    })]);
const RemoteUserStoppedTypingSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_user_stopped_typing"),
    })]);
const RemoteUserToggledReactionSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_user_toggled_reaction"),
        messageId: Type.BigInt(),
        reaction: Type.String(),
        added: Type.Boolean(),
    })]);
const RemoteUserRemovedMessageSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_user_removed_message"),
        messageId: Type.BigInt(),
    })]);
const RemoteUserDeletedMessageSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_user_deleted_message"),
        messageId: Type.BigInt(),
    })]);
const RemoteUserUndeletedMessageSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_user_undeleted_message"),
        messageId: Type.BigInt(),
    })]);
const RemoteUserReadMessageSchema = Type.Intersect([WebRtcMessageCommonSchema, Type.Object({
        kind: Type.Literal("remote_user_read_message"),
        messageId: Type.BigInt(),
    })]);
